import { useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import Screen from "components/Meta/Screen";
import MelhousTabs from "./Components/MelhousTabs";
import MelhousHome from "./views/MelhousHome";
import MelhousBoard from "./views/MelhousBoard";
import ConfigColor from "./views/ConfigColor";
import ModelMelhous from "./models/ModelMelhous";
import ModelMelhousEngage from "./models/ModelMelhousEngage";
import ModelMelhousRequest from "./models/ModelMelhousRequest";
import ModelPqrs from "./models/ModelPqrs";
import {
  MELHOUS_TABS,
  VIEW_HOME,
  VIEW_HOTEL,
  VIEW_ENGAGE,
  VIEW_REQUESTS,
  VIEW_PQRS,
  VIEW_APPEARANCE,
} from "./constants";

function ScreenMelhousDash() {
  const [view, setView] = useState(VIEW_HOME);

  return (
    <Screen style="w-full flex flex-col min-h-screen bg-neutral-100">
      <header className="px-3 lg:px-4 pt-4 pb-2">
        <h1 className="text-2xl md:text-3xl font-light text-neutral-700">
          Melhous
        </h1>
        <p className="text-sm text-neutral-500">
          <FM id="melhous.dash.help" />
        </p>
      </header>
      <MelhousTabs tabs={MELHOUS_TABS} current={view} onChange={setView} />
      <main className="w-full flex-1 overflow-y-auto">
        {view === VIEW_HOME && <MelhousHome onOpen={setView} />}
        {view === VIEW_HOTEL && (
          <MelhousBoard
            model={ModelMelhous}
            notice="melhous.dash.hotel_notice"
          />
        )}
        {view === VIEW_ENGAGE && (
          <MelhousBoard
            model={ModelMelhousEngage}
            notice="melhous.dash.recommendation_notice"
          />
        )}
        {view === VIEW_REQUESTS && <MelhousBoard model={ModelMelhousRequest} />}
        {view === VIEW_PQRS && <MelhousBoard model={ModelPqrs} />}
        {view === VIEW_APPEARANCE && (
          <div className="p-3 lg:p-4">
            <ConfigColor />
          </div>
        )}
      </main>
    </Screen>
  );
}

export default ScreenMelhousDash;
